import { render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";
import { CanvasDataWidgetRenderer } from "./CanvasDataWidgetRenderer";
jest.mock("./CanvasKanbanRenderer", () => ({
  CanvasKanbanRenderer: () => <div>Kanban runtime</div>,
}));
jest.mock("./CanvasCalendarRenderer", () => ({
  CanvasCalendarRenderer: () => <div>Calendar runtime</div>,
}));
jest.mock("./CanvasRelatedRecordsRenderer", () => ({
  CanvasRelatedRecordsRenderer: () => <div>Related runtime</div>,
}));
test.each([
  ["kanban", "Kanban runtime"],
  ["calendar", "Calendar runtime"],
  ["related_records", "Related runtime"],
])("dispatches %s through the shared runtime", (type, label) => {
  render(
    <CanvasDataWidgetRenderer
      element={{
        id: type,
        type,
        gridColumn: 1,
        gridRow: 1,
        columnSpan: 12,
        rowSpan: 4,
        props: {},
      }}
      dataSources={[]}
      canvasId="canvas"
    />,
  );
  expect(screen.getByText(label)).toBeInTheDocument();
});
